import { render, staticRenderFns } from "./detailsSalesVolumeNew2.vue?vue&type=template&id=713c6708&scoped=true&"
import script from "./detailsSalesVolumeNew2.vue?vue&type=script&lang=js&"
export * from "./detailsSalesVolumeNew2.vue?vue&type=script&lang=js&"
import style0 from "./detailsSalesVolumeNew2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailsSalesVolumeNew2.vue?vue&type=style&index=1&id=713c6708&lang=scss&scoped=true&"
import style2 from "./detailsSalesVolumeNew2.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713c6708",
  null
  
)

component.options.__file = "detailsSalesVolumeNew2.vue"
export default component.exports